<template>
	<v-app id="app">
		<AppAlert />
		<AppBar v-if="this.$route.path != '/exemplos'" />
		<AppContent v-if="!loading" />
		<AppLoading v-if="loading" />
	</v-app>
</template>
<script>
import AppBar from './components/template/AppBar'
import AppContent from './components/template/AppContent'
import AppLoading from './components/widgets/AppLoading'
import AppAlert from './components/widgets/AppAlert'

export default {
	components: {
		AppBar,
		AppContent,
		AppLoading,
		AppAlert
	},
	data: function () {
		return {
			loading: false,
			
			rotasPublicas: ['Signin', 'Signup'],

		}
	},
	methods: {
	},
	computed: {
	
	},
	mounted() {
		
	},
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');

.v-application {
	font-family: 'Inter';
}
</style>